import { translate, translateFormatter, type RichTextFormatter } from '@/domains/core/localization/translate';
export const {
  reviewsStatsTitleAbout,
  reviewsStatsTitle,
  reviewConsumerInformationRoute,
  reviewsStatsRecommendationsNumber,
  reviewsEvaluationsOfCustomers,
  reviewsStatsRecommendationsPercentage,
  reviewsStarOne,
  reviewsStarOther,
  reviewsStarZero,
  reviewsAllCommentsTitle,
  reviewsAllComments,
  reviewsProductRecommeneded,
  reviewsShowLess,
  reviewsShowMore,
  reviewsViewMore,
  reviewsLastestReviews,
  reviewsLeastPositive,
  reviewsMonitoredReviews,
  reviewsMostHelpful,
  reviewsMostPositive,
  reviewsNoReviews,
  reviewsSeeAll,
  reviewsBlockTitle,
  reviewsToday,
  latestReviewsSelectOption,
  usefulReviewsSelectOption,
  relevantReviewsSelectOption,
  sortInputTitle,
  headerTitle,
  headerFilterLabel,
  orderedByRelevanceAndDate,
  customerReviews
} = translate({
  "orderedByRelevanceAndDate": "The reviews are displayed in chronological order, with the most relevant reviews displayed first.",
  "reviewsStatsTitleAbout": "About reviews",
  "reviewsStatsRecommendationsNumber": "DIY reviews by customers",
  "reviewsStatsRecommendationsPercentage": "DIY enthusiasts recommend this product",
  "reviewsStatsTitle": "DIY reviews by customers",
  "reviewConsumerInformationRoute": "/consumer-information",
  "reviewsEvaluationsOfCustomers": "Customer evaluations",
  "reviewsStarOne": "star",
  "reviewsStarOther": "stars",
  "reviewsStarZero": "stars",
  "reviewsAllCommentsTitle": "All reviews",
  "sortInputTitle": "Sort by",
  "latestReviewsSelectOption": "Most recent",
  "usefulReviewsSelectOption": "Most voted",
  "relevantReviewsSelectOption": "Most relevant",
  "reviewsAllComments": "See all reviews",
  "reviewsProductRecommeneded": "Yes, I would recommend this product",
  "reviewsShowLess": "Show less",
  "reviewsShowMore": "Show more",
  "reviewsViewMore": "View More",
  "reviewsLastestReviews": "Latest reviews",
  "customerReviews": "Customer reviews",
  "reviewsLeastPositive": "The least positive",
  "reviewsMonitoredReviews": "Reviews are monitored by ManoMano",
  "reviewsMostHelpful": "The most helpful",
  "reviewsMostPositive": "The most positive",
  "reviewsNoReviews": "Oops!\\nNo comments yet.",
  "reviewsSeeAll": "View all",
  "reviewsBlockTitle": "Reviews",
  "reviewsToday": "Today",
  "headerTitle": "Reviews",
  "headerFilterLabel": "Reviews from ManoManoPro"
});
export const reviewsOneDay = translateFormatter<{
  total: number;
}>("{total} day ago", undefined, undefined, "en");
export const reviewsOtherDay = translateFormatter<{
  total: number;
}>("{total} days ago", undefined, undefined, "en");
export const reviewsOneGlobalRating = translateFormatter<{
  total: number;
  strong: RichTextFormatter;
}>("Overall rating out of <strong>{total}</strong> customer review", undefined, undefined, "en");
export const reviewsOtherGlobalRating = translateFormatter<{
  total: number;
  strong: RichTextFormatter;
}>("Overall rating out of <strong>{total}</strong> customer reviews", undefined, undefined, "en");
export const reviewsOneStar = translateFormatter<{
  total: number;
}>("Only view {total} star reviews", undefined, undefined, "en");
export const reviewsOtherStar = translateFormatter<{
  total: number;
}>("Only view {total} star reviews", undefined, undefined, "en");
export const reviewsOneWeek = translateFormatter<{
  total: number;
}>("{total} week ago", undefined, undefined, "en");
export const reviewsOtherWeek = translateFormatter<{
  total: number;
}>("{total} weeks ago", undefined, undefined, "en");